import { apiService as Service } from '@/services/service'

const url = 'search'

/** Treffer der Volltextsuche (GET /search, IndexedRecord mit geladenem Datensatz) */
export type SearchHit = {
	id: number
	/** Morph-Klasse, z.B. App\Model\Building */
	indexable_type: string
	indexable_id: number
	indexed_title?: string | null
	indexed_content?: string | null
	/** Datensatz; die API entfernt Treffer ohne Datensatz */
	indexable: Record<string, unknown> | null
}

export const searchService = {
	/**
	 * Volltextsuche über alle indizierten Modelle. Die API entfernt Treffer per `unset` aus der Collection,
	 * die Antwort kann deshalb ein Objekt mit Zahl-Schlüsseln statt eines Arrays sein.
	 * `silentError`: ein Fehler der Zusatzsuche darf die lokale Dashboard-Suche nicht mit einem Dialog überdecken.
	 */
	search: (q: string, signal?: AbortSignal) =>
		Service.get<SearchHit[] | Record<string, SearchHit>>({
			url,
			params: { q },
			signal,
			meta: { silentError: true },
		}),
}

export default searchService
